import React from 'react';
import robotarm from '../assests/robot_arm.mp4' // Assuming you have an image file

const RobotArm = () => {
  return (
    <div className="w-full min-h-screen text-blue-light bg-gray-100 pt-[120px]">
      <div className="max-w-[900px] mx-auto p-8 flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <h1 className="text-4xl font-bold inline border-b-4 border-blue-dark text-blue-dark">
            Robotic Arm
          </h1>
          <p className="py-6 text-gray-700">
            Inspired by my time at Automate 2024.
          </p>
        </div>
        
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-dark border-b-2">Simulation</h2>
            <div className="mb-8 flex flex-col md:flex-row items-center justify-center gap-8">
            <div className="w-full h-96 md:w-9/12 text-gray-600">
                <p className="py-4 text-gray-600"> 
                My experience with RoboSoccer led to me try creating a simulation with PyBullet.
            I started with creating a URDF file for a simple 3-DoF robotic arm with no end effector.
            Using trignometry, I was able to compute the inverse kinematics for the joint angles, given a target pose.
                </p>
            </div>

            {/* Video */}
            <div className="w-full md:w-auto h-96 rounded shadow-lg flex justify-center">
                <video
                className="h-full object-contain rounded"
                controls
                >
                <source src={robotarm} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
            </div>
          </div>
        </div>
    
      </div>
    </div>
  );
};

export default RobotArm;
